const spkIfiliale = {
  erstedaten: {
    headline: 'In wenigen Schritten zu Ihrer $t(sparkasse.produkt)',
    typ_tt: `<h4>Wohnung oder Haus?</h4>
      <p>Geben Sie hier an, ob Sie den Hausrat in einer Wohnung oder einem Haus versichern möchten.</p>
      <p>Wenn das Haus oder die Wohnung nicht dauerhaft bewohnt sind, lassen Sie sich bitte von Ihrem Sparkassenberater vor Ort beraten.</p>`,
    versicherbar: '<p>Im Internet versichern wir nur dauerhaft bewohnte Objekte. Ferienwohnungen'
      + ' und -häuser oder WG-Zimmer können Sie gern vor Ort bei Ihrem Sparkassenberater'
      + ' versichern.</p>',
    weiter: 'Weiter',
  },
  produktvergleich: {
    Basis: {
      andereLeistungenTooltips: {
        wertsachen_footer: '<p>Bitte wenden Sie sich an Ihren Sparkassenberater vor Ort, falls Ihre Wertsachen in Summe mehr wert sind als {{WERT}}&nbsp;€.</p>',
      },
    },
    Komfort: {
      andereLeistungenTooltips: {
        wertsachen_footer: '<p>Bitte wenden Sie sich an Ihren Sparkassenberater vor Ort, falls Ihre Wertsachen in Summe mehr wert sind als {{WERT}}&nbsp;€.</p>',
      },
    },
    Premium: {
      andereLeistungenTooltips: {
        wertsachen_footer: '<p>Bitte wenden Sie sich an Ihren Sparkassenberater vor Ort, falls Ihre Wertsachen in Summe mehr wert sind als {{WERT}}&nbsp;€.</p>',
      },
    },
    tarif50Plus: {
      andereLeistungenTooltips: {
        wertsachen_footer: '<p>Bitte wenden Sie sich an Ihren Sparkassenberater vor Ort, falls Ihre Wertsachen in Summe mehr wert sind als {{WERT}}&nbsp;€.</p>',
      },
    },
    produkte: {
      vsu_berater: `<h4>Summe zu hoch oder zu niedrig?</h4>
        <p>Sollte Ihr Hausrat mehr oder weniger wert sein, als die berechnete Summe, sprechen Sie Ihren Sparkassenberater vor Ort an.</p>`,
    },
    zusatz: {
      naturgefahren_alert_gk4: '<p>Ihre Adresse befindet sich in einem Risikogebiet. Hier ist eine persönliche Beratung '
          + 'notwendig. Bitte wenden Sie sich an Ihren Sparkassenberater vor Ort.</p>',
      naturgefahren_alert_gk0: '<p>Für Ihre Adresse können wir den Preis nicht exakt bestimmen. Hier ist eine persönliche '
          + 'Beratung notwendig. Bitte wenden Sie sich an Ihren Sparkassenberater vor Ort.</p>',
    },
  },
  personendaten: {
    anschrift_tt: `<h4>Anschrift</h4>
    <p>Der Hausrat wird an der hier genannten Adresse versichert.</p>
    <ul class="list-icn-checkbullet">
      <li><strong>Sie möchten den Hausrat an einer anderen Adresse versichern?</strong> Dann nutzen Sie bitte den Link "Anschrift ändern".</li>
    </ul>
    $t(personendaten.anschrift_tt_subtext)`,
    anschrift_tt_subtext: '<p>Bitte beachten Sie, dass wir im Internet nur dauerhaft bewohnte Objekte versichern. <strong>'
      + 'Für die Versicherung von Ferienwohnungen und -häusern</strong> sprechen Sie gerne Ihren'
      + ' Sparkassenberater vor Ort an.</p>',
  },
  vorversicherung: {
    nichtversicherbar: '<p>Leider können wir Sie nicht im Internet versichern. Wenden Sie sich bitte an Ihren Sparkassenberater vor Ort.</p>',
  },
  zahlungsdaten: {
    headline: 'Abbuchungskonto',
  },
  zusammenfassung: {
    weiter: 'Jetzt beantragen',
  },
};

export default spkIfiliale;
